const VerificationCode = {
  uuid: true,
  scope: true,
  expiresIn: true
};

export default VerificationCode;